// import React, { useState } from "react";
// import { FaStar } from "react-icons/fa";
// import ReCAPTCHA from "react-google-recaptcha";
// import {
//   Box,
//   Button,
//   Paper,
//   TextField,
//   Typography,
//   Stack,
// } from "@mui/material";

// const FeedbackForm = () => {
//   const [rating, setRating] = useState(0);
//   const [hover, setHover] = useState(0);
//   const [name, setName] = useState("");
//   const [email, setEmail] = useState("");
//   const [comments, setComments] = useState("");
//   const [captcha, setCaptcha] = useState(null);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (!captcha) {
//       alert("Please verify you are not a robot!");
//       return;
//     }

//     const formData = { name, email, comments, rating };
//     console.log("Form Submitted:", formData);
//     alert("Feedback submitted successfully!");
//   };

//   return (
//     <Paper
//       elevation={4}
//       sx={{
//         maxWidth: 300,
//         mx: "auto",
//         mt: 4,
//         p: 4,
//         borderRadius: 3,
//         bgcolor: "#fafafa",
//       }}
//     >
//       <Typography variant="h5" fontWeight="bold" gutterBottom>
//         Feedback 
//       </Typography>

//       {/* Rating */}
//       <Box mb={3}>
//         <Typography variant="subtitle1" gutterBottom>
//           Rating
//         </Typography>
//         <Stack direction="row" spacing={1}>
//           {[1, 2, 3, 4, 5].map((star) => (
//             <FaStar
//               key={star}
//               size={32}
//               style={{ cursor: "pointer", transition: "0.2s" }}
//               color={star <= (hover || rating) ? "red" : "#ccc"}
//               onClick={() => setRating(star)}
//             //   onMouseEnter={() => setHover(star)}
//               onMouseLeave={() => setHover(0)}
//             />
//           ))}
//         </Stack>
//       </Box>

//       {/* Form */}
//       <Box component="form" onSubmit={handleSubmit}>
//         <Stack spacing={2}>
//           <TextField
//             label="Name"
//             variant="outlined"
//             fullWidth
//             required
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//           />

//           <TextField
//             label="Email Address"
//             type="email"
//             variant="outlined"
//             fullWidth
//             required
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//           />

//           <TextField
//             label="Comments"
//             variant="outlined"
//             fullWidth
//             multiline
//             rows={3}
//             value={comments}
//             onChange={(e) => setComments(e.target.value)}
//           />

//           {/* reCAPTCHA */}
//           <Box>
//             <ReCAPTCHA
//               sitekey="YOUR_SITE_KEY" // Replace with your real key
//               onChange={(value) => setCaptcha(value)}
//             />
//           </Box>

//           <Button
//             type="submit"
//             variant="contained"
//             sx={{
//               bgcolor: "#1976d2",
//               "&:hover": { bgcolor: "#1565c0" },
//               borderRadius: 2,
//               py: 1.2,
//             }}
//           >
//             Submit
//           </Button>
//         </Stack>
//       </Box>
//     </Paper>
//   );
// };

// export default FeedbackForm;



import React, { useRef, useState } from "react";
import { FaStar } from "react-icons/fa";
import ReCAPTCHA from "react-google-recaptcha";
import {
  Box,
  Button,
  IconButton,
  Paper,
  TextField,
  Typography,
  Stack,
  Divider,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { BASE_URL } from "./config/network/ApiUrl";

const FeedbackForm = ({ onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [comments, setComments] = useState("");
  const [captcha, setCaptcha] = useState(null);
  const [errors, setErrors] = useState({
    name: "",
    email: "",
    captcha: "",
  });
  const [successMessage, setSuccessMessage] = useState("");



  const recaptchaRef = useRef(null);


  const validateForm = () => {
    let tempErrors = {
      name: "",
      email: "",
      captcha: "",
    };

    if (!name.trim()) {
      tempErrors.name = "Please enter your name";
    }

    if (!email.trim()) {
      tempErrors.email = "Please enter your emailid";
    }

    if (!captcha) {
      tempErrors.captcha = "Please fill up the captcha.";
    }

    setErrors(tempErrors);

    // return true only if no errors
    return !tempErrors.name && !tempErrors.email && !tempErrors.captcha;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    // clear previous success
    setSuccessMessage("");

    // Validate first
    if (!validateForm()) {
      return;
    }


    const formData = {
      name: name,
      email: email,
      rating: rating,
      comments: comments,
      "g-recaptcha-response": captcha,

    };

    try {
      const response = await axios.post(`${BASE_URL}api/feedback`, formData);
      console.log("Feedback Submitted:", response);
      setName("")
      setEmail("")
      setComments("")
      setRating(0)
      setCaptcha(null)
      // Reset reCAPTCHA checkbox
      recaptchaRef.current?.reset();
      setSuccessMessage("Thank you for submitting the feedback..");

    } catch (error) {
      console.error("Error submitting feedback:", error);
      if (error?.response) {
        alert(`Error: ${error?.response?.data?.error || "Something went wrong!"}`);
      } else if (error?.request) {
        alert("No response from server. Please check your connection.");
      } else {
        alert("Unexpected error. Please try again later.");
      }
    }
  };

  return (
    <Paper
      elevation={6}
      sx={{
        width: { xs: "95vw", sm: "420px" },
        maxWidth: "85vw",
        maxHeight: { xs: "84vh", sm: "84vh" },
        overflowY: "auto",
        p: { xs: 2, sm: 4 },
        position: "relative",
        boxShadow: "0px 4px 20px rgba(0,0,0,0.25)",
        bgcolor: "#fff",
        // borderRadius: { xs: "8px", sm: "12px" },
        mx: { xs: 1, sm: 0 },
      }}
    >
      {/* Header */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={1}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 500,
            fontFamily: "Roboto, sans-serif",
            color: "#333",
            fontSize: { xs: "22px", sm: "26px" }
          }}
        >
          Feedback
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{
            color: "#555",
            p: { xs: 0.5, sm: 1 }
          }}
          size={isMobile ? "small" : "medium"}
        >
          <CloseIcon fontSize={isMobile ? "small" : "medium"} />
        </IconButton>
      </Box>

      {/* Sub-header */}
      <Box
        display="flex"
        justifyContent="flex-end"
        mb={1}
      >
        <Typography
          variant="body2"
          sx={{
            color: "#076766",
            fontSize: { xs: "12px", sm: "13px" },
            fontFamily: "'OpenSans-Regular'"
          }}
        >
          * Fields are mandatory
        </Typography>
      </Box>

      <Divider sx={{ mb: { xs: 1.5, sm: 2 } }} />

      {/* Rating */}
      <Box mb={2}>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 500,
            color: "#333",
            mb: 0.5,
            fontSize: { xs: "15px", sm: "16px" }
          }}
        >
          Rating
        </Typography>
        <Stack direction="row" spacing={1}>
          {[1, 2, 3, 4, 5].map((star) => (
            <FaStar
              key={star}
              size={isMobile ? 20 : 24}
              style={{ cursor: "pointer", transition: "0.2s" }}
              color={star <= (hover || rating) ? "#ffc107" : "#ccc"}
              onClick={() => setRating(star)}
              onMouseEnter={() => setHover(star)}
              onMouseLeave={() => setHover(0)}
            />
          ))}
        </Stack>
      </Box>

      {/* Form Fields */}
      <Box component="form" onSubmit={handleSubmit}>
        <Stack spacing={{ xs: 1.5, sm: 1.8 }}>
          <TextField
            label="Name"
            variant="outlined"
            fullWidth
            error={Boolean(errors.name)}
            helperText={errors.name}
            value={name}
            onChange={(e) => {
              setName(e.target.value)

              if (errors.name) {
                setErrors((prev) => ({ ...prev, name: "" }));
              }
            }}
            InputLabelProps={{
              style: { fontSize: isMobile ? 14 : 15 }
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                height: { xs: 36, sm: 40 },
                fontSize: { xs: 14, sm: 15 }
              },
              "& .MuiInputLabel-root": {
                fontSize: { xs: 14, sm: 15 }
              },
              "& .MuiFormHelperText-root": {
                color: "#F00",
                fontSize: "14px",
                lineHeight: "14px",
                fontFamily: "OpenSans-Regular",
                marginLeft: 0,
              },
            }}
            size={isMobile ? "small" : "medium"}
          />

          <TextField
            label="Email address"
            type="email"
            variant="outlined"
            fullWidth
            value={email}
            onChange={(e) => {
              setEmail(e.target.value)

              if (errors.email) {
                setErrors((prev) => ({ ...prev, email: "" }));
              }
            }}
            error={Boolean(errors.email)}
            helperText={errors.email}
            InputLabelProps={{
              style: { fontSize: isMobile ? 14 : 15 }
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                height: { xs: 36, sm: 40 },
                fontSize: { xs: 14, sm: 15 }
              },
              "& .MuiInputLabel-root": {
                fontSize: { xs: 14, sm: 15 }
              },
              "& .MuiFormHelperText-root": {
                color: "#F00",
                fontSize: "14px",
                lineHeight: "14px",
                fontFamily: "OpenSans-Regular",
                marginLeft: 0,
              },

            }}
            size={isMobile ? "small" : "medium"}
          />

          <TextField
            label="Comments"
            variant="outlined"
            fullWidth
            multiline
            rows={isMobile ? 3 : 2}
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            InputLabelProps={{
              style: { fontSize: isMobile ? 14 : 15 }
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                fontSize: { xs: 14, sm: 15 }
              },
              "& .MuiInputLabel-root": {
                fontSize: { xs: 14, sm: 15 }
              }
            }}
            size={isMobile ? "small" : "medium"}
          />

          {/* reCAPTCHA - Responsive */}
          <Box mt={1}>
            <Box
              sx={{
                transform: isMobile ? "scale(0.85)" : "scale(1)",
                transformOrigin: "0 0",
                maxWidth: isMobile ? "300px" : "100%",
                overflow: "hidden"
              }}
            >
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey="6LewAQosAAAAACvO2L6Y36ySyUWiTADc3vtvQGnL"
                onChange={
                  (value) => {
                    setCaptcha(value)
                    setErrors((prev) => ({ ...prev, captcha: "" }));
                    console.log("ReCAPTCHA value", value)
                  }
                }
                size={"normal"}
                value={captcha}
              />
            </Box>

            {errors.captcha && (
              <Typography
                sx={{
                  color: "#cb2b2b",
                  fontSize: "12px",
                  lineHeight: "12px",
                  mt: 0.5,
                  fontFamily: "OpenSans-Regular",
                }}
              >
                {errors.captcha}
              </Typography>
            )}


          </Box>


          {/* Submit Button */}
          <Box
            sx={{
              display: "flex",
              // justifyContent: "center",
              // mt: { xs: 0.5, sm: 0.5 }
            }}
          >
            {/* <Button
              type="submit"
              variant="contained"
              sx={{
                bgcolor: "#5f5f5f",
                textTransform: "none",
                fontWeight: 500,
                fontSize: { xs: "13px", sm: "14px" },
                borderRadius: "20px",
                px: { xs: 4, sm: 5 },
                py: { xs: 0.7, sm: 0.8 },
                minWidth: { xs: "140px", sm: "auto" },
                "&:hover": { bgcolor: "#4a4a4a" },
              }}
              size={isMobile ? "small" : "medium"}
            >
              Submit
            </Button> */}

            <Button
              type="submit"
              variant="contained"
              sx={{
                mt: 0.5,
                bgcolor: "#767676",
                textTransform: "none",
                fontSize: "16px",
                borderRadius: "20px",
                height: "30px",
                color: "#fff",
                maxWidth: "200px",
                px: 10,
                py: 0.4,
                alignSelf: "flex-start",
              }}
            >
              Submit
            </Button>
          </Box>
          {successMessage && (
            <Typography
              sx={{
                color: "#008000", 
                fontSize: "16px",
                fontFamily: "OpenSans-Regular",
              }}
            >
              {successMessage}
            </Typography>
          )}

        </Stack>
      </Box>
    </Paper>
  );
};

export default FeedbackForm;



